import { Skeleton } from "@mui/material";

const PrimarySkeleton = () => {
  return (
    <Skeleton className={`!h-[20px] md:!h-[18px] sm:!h-[16px]`} />
  )
}

export default PrimarySkeleton